import { createContext } from "react";

export  const loginContext = createContext({})
export const customerContext = createContext({})
export const valueContext = createContext({})
export const adminDrawerContext = createContext({})
export const distributorContext = createContext({})
export const distributorUserContext = createContext({})